export default __webpack_public_path__ + "static/media/new-destination-img.0f32eecf.svg";